import { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import useSidebarState from '../../../hooks/useSidebarState';

const SidebarLayoutContext = createContext(null);

export function SidebarProvider({ children }) {
  const sidebarState = useSidebarState();
  const value = useMemo(() => sidebarState, [sidebarState]);

  return (
    <SidebarLayoutContext.Provider value={value}>
      {children}
    </SidebarLayoutContext.Provider>
  );
}

SidebarProvider.propTypes = {
  children: PropTypes.node,
};

export function useSidebarLayout() {
  const context = useContext(SidebarLayoutContext);
  if (!context) {
    throw new Error('useSidebarLayout must be used within SidebarProvider');
  }
  return context;
}

export default SidebarLayoutContext;
